import type { FaireProductEntity } from "../../entity_types/product";

export const p_v63q6neadh: FaireProductEntity = {
  token: "p_v63q6neadh",
  type: "product",
  name: "Grateful Dead Dancing Bear Bobbleheads",
  brandToken: "b_2pgyi0ok2w",
  brandName: "National Bobblehead Hall of Fame and Museum",
  imageUrl:
    "https://cdn.faire.com/fastly/a50e48b6b769696886b6e8bb73c1e336696edaab1ed7756bd2ded79c89e28df2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/790fbb297672746f27a3b182e02e6bb1d130bd8f2c6955049cb53c2882b6b72d.png",
    "https://cdn.faire.com/fastly/deddb33d03abc6154ee34c65c4da451d938336b0cb269a58e403bdf4adde81e9.png",
    "https://cdn.faire.com/fastly/3c9de9d0647c619ac3c07c715f46c98eb5472a69ca40769134a6c852b8e48fd0.png",
    "https://cdn.faire.com/fastly/e77dcb5cb79f1f4098edf2d0e1297d76f2cf9aacd413ea2fd8101403f070ffcf.png",
    "https://cdn.faire.com/fastly/dce4a60ebfb54503959ebb3e686a2c855ca5e8896b4b49405c72fa7070beb6e2.png",
    "https://cdn.faire.com/fastly/464eb1af0e41f9198232f98eae4f05e8df042fd161bdc3b82d0d993157643d7c.png",
    "https://cdn.faire.com/fastly/7656085eeea355dff82126f618d0efefc14a716efa268138b76fc3296ebacdcf.png",
    "https://cdn.faire.com/fastly/2924b079ffd175570235a66f39aa55eedaef2990dbf9bc40743d50a5207ea330.png",
    "https://cdn.faire.com/fastly/3d9ad1d709115d17a2c62d97d66759b563bc8169f316c8279289542628c915f3.png",
    "https://cdn.faire.com/fastly/ea0ae983937593cce502955202bb9cd45e6ad6c291e3347def6611191a328232.png",
    "https://cdn.faire.com/fastly/25f99de94f86575b1afb92eae1e246b5b778621253e944a853850128139cc674.png",
  ],
  priceDollars: 18,
  description:
    "Order your Grateful Dead Dancing Bear Bobbleheads before it's too late. They are officially licensed by the Grateful Dead.\n\n * In stock and ships now \n * Bobbleheads are high quality and produced by Kollectico \n * Limited Edition ",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:12.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
